import React from 'react';
import {Svg} from "assets";
import {useModal} from "utils";
import {renderSelectTrip} from "../constants";
import {AddTrip} from "./addTrip";

export const AddSelectedTrip = ({tripId, afterSuccess, requestParams}) => {
    const {openModal, close} = useModal();

    const openAddTrip = (tripDetails) => {
        openModal(
            <AddTrip
                tripDetails={tripDetails}
                tripId={tripId}
                afterSuccess={afterSuccess}
                requestParams={requestParams}
            />, {
                noShowCloseBtn: true,
                padding: "noPaddings",
                maxWidth: 1325,
                dontClose: true,
            })
    }

    return (
        <div className='add-trip-modal-wrapper'>
            <div className='modal-header-main'>
                <div>
                    <h3 className="modal-header-title">
                        Select The Trip Type
                    </h3>

                    <p className="modal-header-description">
                        Choose the type of trip you want to create.
                    </p>
                </div>

                <button
                    className="modal-close-btn-main"
                    type="button"
                    onClick={close}
                    style={{alignSelf: 'flex-start'}}
                >
                    <Svg.CloseSvg/>
                </button>
            </div>

            <div className="modal-body-main">
                <div className='select-trips-types-modal-wrapper'>
                    {renderSelectTrip.map(({Icon, title, tripDetails, iconBackground}) => (
                        <div className='select-trip-types-modal-item-wrapper'
                             key={tripDetails?.tripType}
                             onClick={() => openAddTrip(tripDetails)}
                        >
                            <div className='select-trip-types-modal-item-icon' style={{background: iconBackground}}>
                                {Icon}
                            </div>

                            <p className='select-trip-types-modal-item-title'>
                                {title}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

